var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKybernetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for Kybe rNetwork",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kyber Network") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "#BDFAE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3300_8583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7234 50.9953L71.1276 64.4503C71.3157 64.5638 71.5305 64.6249 71.75 64.6275C71.9694 64.63 72.1856 64.5739 72.3762 64.4648C72.5669 64.3557 72.7251 64.1977 72.8348 64.0069C72.9444 63.8161 73.0014 63.5994 73 63.3792V38.5926C73.0028 38.372 72.9464 38.1546 72.8368 37.9634C72.7272 37.7721 72.5684 37.6139 72.377 37.5054C72.1856 37.3969 71.9686 37.342 71.7488 37.3464C71.5291 37.3509 71.3145 37.4146 71.1276 37.5308L47.7234 50.9953Z",
    fill: "#31CB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6315 31.5738L54.6323 19.763C54.4667 19.6354 54.2723 19.5506 54.0663 19.5162C53.8603 19.4817 53.649 19.4986 53.451 19.5655C53.2531 19.6323 53.0746 19.747 52.9312 19.8994C52.7878 20.0519 52.684 20.2374 52.6289 20.4395L46.7872 46.7483L70.4911 33.5939C70.6714 33.5008 70.8248 33.3626 70.9364 33.1926C71.048 33.0226 71.1141 32.8266 71.1282 32.6235C71.1423 32.4205 71.104 32.2172 71.017 32.0333C70.93 31.8494 70.7972 31.6911 70.6315 31.5738Z",
    fill: "#31CB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6136 82.218L70.6315 70.4073C70.7994 70.2888 70.9343 70.129 71.023 69.9432C71.1118 69.7574 71.1514 69.5518 71.1383 69.3462C71.1251 69.1406 71.0596 68.9418 70.9479 68.7689C70.8362 68.5961 70.6821 68.4549 70.5004 68.359L46.7872 55.2046L52.6289 81.5133C52.6774 81.7177 52.7757 81.9069 52.915 82.0637C53.0543 82.2206 53.2302 82.3402 53.427 82.412C53.6238 82.4837 53.8352 82.5052 54.0423 82.4747C54.2494 82.4441 54.4457 82.3624 54.6136 82.2368",
    fill: "#31CB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6383 50.5068L47.7234 21.943C47.7699 21.7063 47.7449 21.4611 47.6517 21.2387C47.5585 21.0163 47.4013 20.8269 47.2002 20.6947C46.9992 20.5625 46.7634 20.4936 46.523 20.4967C46.2827 20.4998 46.0487 20.5748 45.8511 20.7121L30.2638 32.7108C29.8691 33.0147 29.5497 33.406 29.3305 33.8542C29.1113 34.3024 28.9982 34.7954 29 35.2947V65.7376C28.9923 66.2433 29.1027 66.7437 29.3221 67.1988C29.5415 67.654 29.8641 68.0514 30.2638 68.3591L45.7762 80.3202C45.9738 80.4575 46.2078 80.5325 46.4481 80.5356C46.6885 80.5387 46.9243 80.4698 47.1254 80.3376C47.3264 80.2054 47.4836 80.016 47.5768 79.7936C47.67 79.5713 47.695 79.326 47.6485 79.0893L41.6383 50.5068Z",
    fill: "#31CB9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3300_8583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 63,
    fill: "white",
    transform: "translate(29 19.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKybernetwork);
export default __webpack_public_path__ + "static/media/kybernetwork.e99e19d18309a1fed7da17c8f1030cc7.svg";
export { ForwardRef as ReactComponent };